import React, { useEffect, useState } from 'react';

import useTranslate from '../../../../common/hooks/useTranslate';
import { Outlet, useMatch, Navigate, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { getActiveInvestors } from '../../../services/investorsService';

import { orderBy } from '@progress/kendo-data-query';

import { INVESTOR, POPUP } from '../../../../redux/types';

import { IInvestor } from '../../../services/types/IInvestor';

import Main from '../../../layout/main/main';

import './boardsContainer.scss';

const BoardsContainer: React.FC = () => {
  const [investorLoading, setInvestorLoading] = useState<boolean>(true);
  const [investors, setInvestors] = useState<any[]>([]);
  const [noInvestors, setNoInvestors] = useState<boolean>(false);

  const { t } = useTranslate();
  let match = useMatch('/boards');
  const dispatch = useDispatch();
  let navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;
    getActiveInvestors()
      .then((res: IInvestor[]) => {
        let dataArr = [];
        if (res.length === 0) {
          setNoInvestors(true);
        } else {
          res.forEach((item) => {
            dataArr.push({ name: item.name, id: item.objectId });
          });
          if (isMounted) {
            setInvestors(orderBy(dataArr, [{ field: 'name', dir: 'asc' }]));
            setInvestorLoading(false);
            dispatch({ type: INVESTOR.SET_INVESTOR, investor: dataArr[0] });
          }
        }
      })
      .catch((err) => {
        dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message });
        setInvestorLoading(false);
      });

    return () => {
      isMounted = false;
      setInvestors([]);
      setInvestorLoading(true);
      setNoInvestors(false);
    };
  }, []);

  const onChange = (e) => {
    dispatch({ type: INVESTOR.SET_INVESTOR, investor: e.value });
    navigate(`/boards/${e.value.id}`, { replace: true });
  };

  return (
    <Main className='boards-wrapper' title={t('BOARDS.PAGE_TITLE')} investorDropdown={!noInvestors}
          investors={investors} onInvestorChange={onChange}>
      {noInvestors ? (
        <div className='no-boards-message-wrapper'>
          <p>{t('BOARDS.NO_BOARDS')}</p>
        </div>
      ) : (
        <>{match && !investorLoading ? <Navigate to={`./${investors[0].id}`} /> : <Outlet />}</>
      )}
    </Main>
  );
};

export default BoardsContainer;
